<!--
 * @Author: your name
 * @Date: 2021-08-18 09:50:33
 * @LastEditTime: 2022-03-18 16:15:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\explorer\NewMediaList\DownloadList.vue
-->
<template>
  <div class="download-table">
    <div class="handel-load">
      <el-button round size="mini" @click="allUploadPlay">{{$t('explorer.StartAll')}}</el-button>
      <el-button round size="mini" @click="allUploadPause">{{$t('explorer.StopAll')}}</el-button>
      <el-button round size="mini" @click="clearAllSuccess">{{$t('explorer.EmptyFinish')}}</el-button>
      <el-button round size="mini" @click="allCancelupload">{{$t('explorer.CancelAll')}}</el-button>
      <div>
        <img
          class="icon"
          style="margin-left: 15px; margin-top: 4px;"
          src="@imgpub/public_openarrow.png"
          @click="$emit('isShowDownloadList',false)"
        />
      </div>
    </div>
    <div class="table-list">
      <el-table :data="mediaUpList" :show-header="false" :empty-text="$t('explorer.NoFiles')" style="width: 100%" height="100%">
        <el-table-column prop="name" :label="$t('explorer.name')" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('explorer.Status')">
          <template slot-scope="scope">
            <el-progress
              :format="format"
              :percentage="scope.row.status === 'success' ? scope.row.percentage:scope.row.percentage === 100 ? 99:scope.row.percentage"
            ></el-progress>
          </template>
        </el-table-column>
        <el-table-column :label="$t('explorer.Check')" width="100">
          <template slot-scope="scope">
            <div class="operation">
              <img
                class="icon"
                v-show="scope.row.status === 'success'"
                src="@imgpub/public_preview.png"
                :title="$t('explorer.Check')"
                @click.stop="handlePreview (scope.$index,{type: scope.row.response.data.type, ref_url: scope.row.response.data.url})"
              />
              <img
                class="icon"
                v-show="scope.row.status === 'uploading'"
                src="@imgpub/pause.png"
                @click="uploadPause(scope.$index, scope.row)"
                :title="$t('explorer.Stop')"
              />
              <img
                class="icon"
                v-show="scope.row.status === 'stop'"
                src="@imgpub/play.png"
                @click="uploadPlay(scope.$index, scope.row)"
                :title="$t('explorer.Start')"
              />
              <img
                class="icon"
                v-show="scope.row.status !== 'success'"
                src="@imgpub/public_cancelupload.png"
                @click="cancelupload(scope.$index, scope.row)"
                :title="$t('explorer.Cancel')"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <preview :previewData="previewData" @previewVisible="previewVisible"></preview>
  </div>
</template>

<script>
import Preview from '@/components/basics/Preview'
import { mPreview } from "@/components/basics/mixins";
export default {
  name: "DownloadList",
  mixins: [mPreview],
  props: {
    mediaUpList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 上传进度显示格式化
    format(percentage) {
      return percentage === 100 ? this.$t('explorer.finish') : `${parseInt(percentage)}%`;
    },
    retransmission(index) {
      this.$emit('retransmission', index);
    },
    cancelupload(index) {
      this.$emit('cancelupload', index);
    },
    uploadPause(index) {
      this.$emit('uploadPause', index);
    },
    uploadPlay(index) {
      this.$emit('uploadPlay', index);
    },
    // 开始所有
    allUploadPlay() {
      this.$emit('allUploadPlay');
    },
    // 停止所有
    allUploadPause() {
      this.$emit('allUploadPause');
    },
    // 清除全部完成
    clearAllSuccess() {
      this.$emit('clearAllSuccess');
    },
    // 取消全部
    allCancelupload() {
      this.$emit('allCancelupload');
    }
  },
  components: {
    Preview
  }
}
</script>

<style lang="scss" scoped>
.download-table {
  color: #000;
  width: 100%;
  height: 100%;
  .handel-load {
    height: 38px;
    background-color: #fff;
    border-bottom: 2px solid #ebeef5;
    display: flex;
    // justify-content:flex-end;
    align-items: center;
  }
  .table-list {
    height: calc(100% - 40px);
  }
  // /deep/ .el-table__header-wrapper {
  //   .cell {
  //     font-size: 18px;
  //     color: #2fb3ff;
  //   }
  //   th:last-child > .cell {
  //     text-align: center;
  //   }
  //   @media screen and (min-width: 1200px) {
  //     th:nth-last-child(2) > .cell {
  //       text-align: center;
  //     }
  //   }
  // }
  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .icon {
      margin: 0px;
    }
  }
  .icon {
    width: 30px;
    height: 30px;
    margin-right: 5px;
  }
}
</style>